<template>
  <v-breadcrumbs class="btn-cap px-0 text-subtitle-1" :items="items">
    <template v-slot:divider>
      <v-icon>fa-solid fa-chevron-right</v-icon>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true },
  },
};
</script>

<style>
</style>